import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import './sidebar.css';
import { useNavigate } from 'react-router-dom';
import { Image } from "@fluentui/react-components";
import { CommonInfo } from '../../CommonData/Config';
import { Button, Tooltip } from "@fluentui/react-components";
import { SlideTextRegular } from "@fluentui/react-icons";
import type { TooltipProps } from "@fluentui/react-components";
import { useTranslation } from 'react-i18next';
import packageJson from "../../../package.json";
import { ROUTES } from '../../CommonData/RouteConstants';

const Commondata = CommonInfo;
interface AnotherComponentProps {
    authToken: string | null;
    LoguserName: string | null;
}



export const Default = (props: Partial<TooltipProps>) => (
    <Tooltip content="Example tooltip" relationship="label" {...props}>
        <Button icon={<SlideTextRegular />} size="large" />
    </Tooltip>
);

const Sidenav: React.FC<AnotherComponentProps> = ({ authToken, LoguserName }) => {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(() => {
        // Retrieve the saved state from localStorage, or fallback to Commondata.SideToggle if not found
        const savedState = localStorage.getItem("isOpen");
        return savedState !== null ? JSON.parse(savedState) : false;
    });
    const [isSelected, setIsSelected] = useState(window.location.pathname);
    const navigate = useNavigate();

    const handleToggle = () => {
        const newState = !isOpen;  // Toggle the current state
        setIsOpen(newState);       // Update the local state
        localStorage.setItem("isOpen", JSON.stringify(newState));  // Store the new state in localStorage
        Commondata.SideToggle = newState;
    };

    const handleItemClick = (path: string) => {
        setIsSelected(path);
        navigate(path);
        // localStorage.setItem('currentUrl', window.location.pathname);
    };

    useEffect(() => {
        localStorage.setItem('currentUrl', window.location.pathname);
    }, []);
    const theme = localStorage.getItem('Theme')

    let startX = 0;

    const handleMoveStart = (event: any) => {
        if (event?.target?.tagName === 'DIV') {
            startX = event?.clientX || event?.touches[0].clientX;
            window.addEventListener('mousemove', handleMove);
            window.addEventListener('touchmove', handleMove);
            window.addEventListener('mouseup', handleMoveEnd);
            window.addEventListener('touchend', handleMoveEnd);
        }
    };

    const handleMove = (event: any) => {
        const movementX = (event?.clientX || event?.touches[0].clientX) - startX;
        if (movementX !== 0) {
            handleToggle();
        }
        startX = event?.clientX || event?.touches[0]?.clientX;
    };

    const handleMoveEnd = () => {
        window.removeEventListener('mousemove', handleMove);
        window.removeEventListener('touchmove', handleMove);
        window.removeEventListener('mouseup', handleMoveEnd);
        window.removeEventListener('touchend', handleMoveEnd);
    };

    const onMouseEnterEvent = () => {
        setIsOpen(true);
        localStorage.setItem("isOpen", JSON.stringify(true));
        Commondata.SideToggle = true;
    };

    const onMouseLeaveEvent = () => {
        setIsOpen(false);
        localStorage.setItem("isOpen", JSON.stringify(false));
        Commondata.SideToggle = false;
    };

    return (
        <div className={theme === 'dark' ? 'side_back_dark' : 'side_back'} onMouseEnter={onMouseEnterEvent} onMouseLeave={onMouseLeaveEvent}>
            <div className={`${theme === 'dark' ? 'sidenav_dark' : 'sidenav'} ${isOpen ? 'sidenav-open' : ''}`}>
                <ul className="sidenav-list">
                    {/* <li className={theme === 'dark' ? 'sidenav-header_dark' : "sidenav-header"}>
                        <Image id="header-img" src={CommonInfo.folderName + "/Resourcelogo.svg"} />
                        <span className={`header-text ${!isOpen ? 'opacity-none' : ''}`}>RX Settings</span>
                    </li> */}
                    {!isOpen &&
                        <Tooltip content="Work Places" relationship="label" >
                            <li
                                className={`${theme === 'dark' ? 'sidenav-item_dark' : 'sidenav-item'} ${isSelected === ROUTES.WORKPLACES ? (theme === 'dark' ? 'item-background_dark' : 'item-background') : ''}`}
                                onClick={() => handleItemClick(ROUTES.WORKPLACES)}><Image id="img" src={`${CommonInfo.folderName}${theme === 'dark' ? '/workplacelight.svg' : '/workplace.svg'}`} />
                            </li></Tooltip>
                    }

                    {isOpen && <li
                        className={`${theme === 'dark' ? 'sidenav-item_dark' : 'sidenav-item'} ${isSelected === ROUTES.WORKPLACES ? (theme === 'dark' ? 'item-background_dark' : 'item-background') : ''}`}
                        onClick={() => handleItemClick(ROUTES.WORKPLACES)}>
                        <Image id="img" src={`${CommonInfo.folderName}${theme === 'dark' ? '/workplacelight.svg' : '/workplace.svg'}`} />
                        <span className={`sidenav-text ${!isOpen ? 'opacity-none' : ''}`}>{t('WorkPlaces')}</span>
                    </li>}
                    {!isOpen && <Tooltip content="Work Place Exceptions" relationship="label"><li
                        className={`${theme === 'dark' ? 'sidenav-item_dark' : 'sidenav-item'} ${isSelected === ROUTES.EXCEPTIONS ? (theme === 'dark' ? 'item-background_dark' : 'item-background') : ''}`}
                        onClick={() => handleItemClick(ROUTES.EXCEPTIONS)}>
                        <Image id="img" src={`${CommonInfo.folderName}${theme === 'dark' ? '/workplaceexceptionlight.svg' : '/workplaceexception.svg'}`} />
                    </li>
                    </Tooltip>}

                    {isOpen && <li
                        className={`${theme === 'dark' ? 'sidenav-item_dark' : 'sidenav-item'} ${isSelected === ROUTES.EXCEPTIONS ? (theme === 'dark' ? 'item-background_dark' : 'item-background') : ''}`}
                        onClick={() => handleItemClick(ROUTES.EXCEPTIONS)}>
                        <Image id="img" src={`${CommonInfo.folderName}${theme === 'dark' ? '/workplaceexceptionlight.svg' : '/workplaceexception.svg'}`} />
                        <span className={`sidenav-text ${!isOpen ? 'opacity-none' : ''}`}>{t('WorkPlaceExceptions')}</span>
                    </li>}
                    {!isOpen &&
                        <Tooltip content="My assigned workspace" relationship="label">
                            <li
                                className={`${theme === 'dark' ? 'sidenav-item_dark' : 'sidenav-item'} ${isSelected === ROUTES.ASSIGNEDSPACE ? (theme === 'dark' ? 'item-background_dark' : 'item-background') : ''}`}
                                onClick={() => handleItemClick(ROUTES.ASSIGNEDSPACE)} >
                                <Image id="assignespace_img" src={`${CommonInfo.folderName}${theme === 'dark' ? '/Desklight.svg' : '/Desk.svg'}`} />
                            </li>
                        </Tooltip>
                    }
                    {/* <Link to="/assignworkplace" className='link-tag'> */}
                    {isOpen && <li
                        className={`${theme === 'dark' ? 'sidenav-item_dark' : 'sidenav-item'} ${isSelected === ROUTES.ASSIGNEDSPACE ? (theme === 'dark' ? 'item-background_dark' : 'item-background') : ''}`}
                        onClick={() => handleItemClick(ROUTES.ASSIGNEDSPACE)} >
                        <Image id="assignespace_img" src={`${CommonInfo.folderName}${theme === 'dark' ? '/Desklight.svg' : '/Desk.svg'}`} />
                        <span className={`sidenav-text ${!isOpen ? 'opacity-none' : ''}`}>{t('MyAssignedWorkspace')}</span>
                    </li>}

                    {/* </Link> */}
                    {!isOpen &&
                        <Tooltip content="My Settings" relationship="label">
                            <li
                                className={`${theme === 'dark' ? 'sidenav-item_dark' : 'sidenav-item'} ${isSelected.includes('/mysettings') ? (theme === 'dark' ? 'item-background_dark' : 'item-background') : ''}`}
                                onClick={() => handleItemClick(ROUTES.getMySettings(0))} >
                                <Image id="img" src={`${CommonInfo.folderName}${theme === 'dark' ? '/Assignspacelight.svg' : '/Assignspace.svg'}`} />
                            </li>
                        </Tooltip>
                    }
                    {isOpen && <li
                        className={`${theme === 'dark' ? 'sidenav-item_dark' : 'sidenav-item'} ${isSelected.includes('/mysettings') ? (theme === 'dark' ? 'item-background_dark' : 'item-background') : ''}`}
                        onClick={() => handleItemClick(ROUTES.getMySettings(0))}
                    >
                        <Image id="img" src={`${CommonInfo.folderName}${theme === 'dark' ? '/Assignspacelight.svg' : '/Assignspace.svg'}`} />
                        <span className={`sidenav-text ${!isOpen ? 'opacity-none' : ''}`}>{t('MySettings')}</span>
                        {/* </Link> */}
                    </li>}
                </ul>
                {/* <div className={theme === 'dark' ? 'toggle-button_dark' : "toggle-button"} onClick={handleToggle}>
                    <div className='center-align'>
                        {isOpen ? <FontAwesomeIcon icon={faAngleLeft} /> : <FontAwesomeIcon icon={faAngleRight} />}
                    </div>
                </div> */}
                <div
                    style={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        height: 50,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        whiteSpace: "nowrap",
                        borderTop: `1px solid ${theme === "dark" ? "#525252" : "#EAEFF5"
                            }`
                    }}
                >
                    {isOpen ? (
                        <span>{t('Version')} {packageJson.version}</span>
                    ) : (
                        <span>v{packageJson.version}</span>
                    )}
                </div>
            </div>
            {/* <div className={`main-content ${isOpen ? 'main-content-shift' : ''}`}>
                {renderSelectedComponent()}
            </div> */}

        </div>
    );
}

export default Sidenav;
